export const salesTeamStatsGridHeaders = [
  {
    sortable: true,
    text: 'Sales Person',
    value: 'SalesPerson',
  },
  {
    sortable: true,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'center',
  },
  {
    sortable: true,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'center',
  },
]

export const salesPersonStatsGridHeaders = [
  {
    sortable: false,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'center',
  },
  {
    sortable: false,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'center',
  },
  {
    sortable: false,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'center',
  },
  {
    sortable: false,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'center',
  },
  {
    sortable: false,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'center',
  },
  {
    sortable: false,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'center',
  },
]

export const customersStatsGridHeaders = [
  {
    sortable: true,
    text: 'Customer',
    value: 'Customer',
  },
  {
    sortable: true,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'center',
  },
  {
    sortable: true,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'center',
  },
  {
    sortable: true,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'center',
  },
]
